<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <AtendimentosSettingsList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import AtendimentosSettingsList from '@/components/settings/AtendimentosSettingsList'

  export default {
    name: 'AtendimentosSettings',
    components: {
      PageTitle,
      PageRowWrapper,
      AtendimentosSettingsList
    }
  }
</script>
